<template>
  <button
    type="button"
    class="password-visibility__toggle"
    :title="`${visible ? 'Hide' : 'Show'} ${fieldLabel}`"
    :aria-label="`${visible ? 'Hide' : 'Show'} ${fieldLabel}`"
    :aria-pressed="String(visible)"
    :disabled="disabled"
    @mousedown.prevent
    @touchstart="rememberFocus"
    @click="toggle"
  >
    <i class="material-icons" aria-hidden="true">{{ visible ? 'visibility_off' : 'visibility' }}</i>
  </button>
</template>

<script>
export default {
  props: {
    visible: { type: Boolean, required: true },
    fieldLabel: { type: String, required: true },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return { restoreFocus: false };
  },
  methods: {
    rememberFocus() {
      this.restoreFocus = document.activeElement === this.$el.parentElement.querySelector('input');
    },
    toggle() {
      this.$emit('toggle');
      if (this.restoreFocus) {
        this.$nextTick(() => this.$el.parentElement.querySelector('input').focus({ preventScroll: true }));
      }
      this.restoreFocus = false;
    },
  },
};
</script>
